import React from 'react';

import { SVGPropsType } from 'src/types';

function DropDownArrow(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M9 4.75003L6 7.75003L3 4.75003"
                stroke={stroke}
                strokeWidth="1.22396"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default DropDownArrow;
